import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37de9dbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex flex-column flex-wrap flex-sm-nowrap p-0" }
const _hoisted_4 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_6 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_7 = { class: "card mb-5 mb-xl-10" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title m-0" }
const _hoisted_10 = { class: "fw-bolder m-0" }
const _hoisted_11 = { class: "card-body p-9" }
const _hoisted_12 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = {
  class: "table align-middle table-row-bordered table-hover fs-5 dataTable no-footer",
  role: "grid"
}
const _hoisted_15 = {
  class: "text-start text-gray-500 fw-bolder fs-5 text-uppercase gs-0",
  role: "row"
}
const _hoisted_16 = {
  key: 0,
  class: "text-start w-25px"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-checkbox__inner" }, null, -1))
const _hoisted_19 = {
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "4"
}
const _hoisted_20 = {
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "2"
}
const _hoisted_21 = {
  class: "text-end",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_22 = {
  key: 1,
  class: "text-end",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_23 = { class: "fw-bold text-gray-800" }
const _hoisted_24 = {
  key: 0,
  class: "text-start"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onUpdate:modelValue", "disabled"]
const _hoisted_27 = { colspan: "4" }
const _hoisted_28 = { class: "w-100" }
const _hoisted_29 = { class: "min-h-60px d-flex align-items-center" }
const _hoisted_30 = { class: "w-60px h-60px me-2" }
const _hoisted_31 = { class: "flex-fill" }
const _hoisted_32 = { class: "mb-1" }
const _hoisted_33 = { class: "mw-500px text-line-clamp-1 break-all" }
const _hoisted_34 = { colspan: "2" }
const _hoisted_35 = { class: "d-flex flex-column" }
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = { class: "me-6" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = { class: "mb-1 fs-6" }
const _hoisted_41 = { class: "text-uppercase" }
const _hoisted_42 = { class: "mb-1 fs-6 text-nowrap" }
const _hoisted_43 = { class: "text-uppercase text-nowrap" }
const _hoisted_44 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_45 = { class: "table-responsive" }
const _hoisted_46 = {
  class: "table align-middle table-row-bordered table-hover fs-5 dataTable no-footer",
  role: "grid"
}
const _hoisted_47 = {
  class: "text-start text-gray-500 fw-bolder fs-5 text-uppercase gs-0",
  role: "row"
}
const _hoisted_48 = {
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_49 = {
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_50 = {
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_51 = {
  class: "text-end",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_52 = { class: "fw-bold text-gray-800" }
const _hoisted_53 = { colspan: "1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = {
  key: 0,
  class: "fs-7 text-gray-400"
}
const _hoisted_56 = { colspan: "1" }
const _hoisted_57 = { colspan: "1" }
const _hoisted_58 = { colspan: "1" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "dataTables_empty p-0 py-4"
}, [
  /*#__PURE__*/_createElementVNode("p", null, "No data found")
], -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-2" }
const _hoisted_63 = { class: "mb-1 fs-6" }
const _hoisted_64 = { class: "text-uppercase" }
const _hoisted_65 = { class: "fs-6" }
const _hoisted_66 = { class: "text-uppercase text-nowrap" }
const _hoisted_67 = {
  key: 1,
  class: "text-end w-60px"
}
const _hoisted_68 = ["disabled", "onClick"]
const _hoisted_69 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "text-start" }
const _hoisted_72 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_73 = { class: "mb-1 fs-6" }
const _hoisted_74 = { class: "text-uppercase" }
const _hoisted_75 = {
  key: 0,
  class: "mb-1 fs-6 text-nowrap"
}
const _hoisted_76 = {
  key: 1,
  class: "fs-6 text-gray-400"
}
const _hoisted_77 = { class: "text-start" }
const _hoisted_78 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_79 = { class: "mb-1 fs-6" }
const _hoisted_80 = { class: "text-uppercase" }
const _hoisted_81 = {
  key: 0,
  class: "mb-1 fs-6 text-nowrap"
}
const _hoisted_82 = {
  key: 1,
  class: "fs-6 text-gray-400"
}
const _hoisted_83 = {
  key: 1,
  class: "text-start"
}
const _hoisted_84 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_85 = { class: "mb-1 fs-6 text-nowrap required" }
const _hoisted_86 = { class: "fs-6 text-gray-400" }
const _hoisted_87 = { class: "text-start" }
const _hoisted_88 = { class: "d-flex flex-column justify-content-center min-w-150px" }
const _hoisted_89 = { class: "mb-1 fs-6" }
const _hoisted_90 = { class: "text-uppercase" }
const _hoisted_91 = {
  key: 0,
  class: "mb-1 fs-6 text-nowrap"
}
const _hoisted_92 = {
  key: 1,
  class: "fs-6 text-gray-400"
}
const _hoisted_93 = { class: "text-start" }
const _hoisted_94 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_95 = { class: "mb-1 fs-6" }
const _hoisted_96 = { class: "text-uppercase" }
const _hoisted_97 = {
  key: 0,
  class: "mb-1 fs-6 text-nowrap"
}
const _hoisted_98 = {
  key: 1,
  class: "fs-6 text-gray-400"
}
const _hoisted_99 = {
  class: "text-start",
  colspan: "2"
}
const _hoisted_100 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_101 = { class: "mb-1 fs-6" }
const _hoisted_102 = { class: "text-uppercase" }
const _hoisted_103 = {
  key: 0,
  class: "mb-1 fs-6 text-nowrap"
}
const _hoisted_104 = {
  key: 1,
  class: "fs-6 text-gray-400"
}
const _hoisted_105 = { class: "text-end" }
const _hoisted_106 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_107 = { class: "mb-1 fs-6" }
const _hoisted_108 = { class: "text-uppercase" }
const _hoisted_109 = {
  key: 0,
  class: "mb-1 fs-6 text-nowrap"
}
const _hoisted_110 = {
  key: 1,
  class: "fs-6 text-gray-400"
}
const _hoisted_111 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_112 = {
  key: 2,
  class: "text-end text-nowrap w-60px"
}
const _hoisted_113 = ["disabled", "onClick"]
const _hoisted_114 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_115 = ["disabled", "onClick"]
const _hoisted_116 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_117 = ["disabled", "onClick"]
const _hoisted_118 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = {
  colspan: "9",
  class: "dataTables_empty"
}
const _hoisted_121 = { key: 0 }
const _hoisted_122 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_127 = ["disabled"]
const _hoisted_128 = { class: "svg-icon svg-icon-3 ms-0 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_item_modal = _resolveComponent("item-modal")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      model: _ctx.formData,
      ref: "formRef",
      rules: _ctx.rules,
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.formData.__show.merchant ? _ctx.formData.__show.merchant + " / " : "") + " " + _toDisplayString(_ctx.formData.__show.channel ? _ctx.formData.__show.channel + " / " : "") + " " + _toDisplayString(_ctx.formData.__show.order_progress), 1),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.formData.request_date)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen013.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.formData.request_date)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("table", _hoisted_14, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_15, [
                      (0)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_16, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                        'opacity-50':
                          _ctx.formData.relation_items.length === 0 || _ctx.loading,
                        'cursor-nodrop':
                          _ctx.formData.relation_items.length === 0 || _ctx.loading,
                      }]),
                              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAllSelect && _ctx.toggleAllSelect(...args)), ["stop"]))
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAllChecked) = $event)),
                                disabled: 
                          _ctx.formData.relation_items.length === 0 || _ctx.loading
                        
                              }, null, 8, _hoisted_17), [
                                [_vModelCheckbox, _ctx.isAllChecked]
                              ]),
                              _hoisted_18
                            ], 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.t("order.product")), 1),
                      _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.t("order.sku")), 1),
                      _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.t("order.quantity")), 1),
                      (0)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_22))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_23, [
                    (_ctx.formData.relation_items.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.relation_items, (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createElementVNode("tr", null, [
                              (0)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                            'cursor-nodrop':
                              (_ctx.formData.order_progress ===
                                _ctx.OrderRequestProgress.Requested &&
                                item.confirmed_flag === 1) ||
                              (_ctx.formData.order_progress ===
                                _ctx.OrderRequestProgress.Confirmed &&
                                item.shipped_flag === 1),
                          }]),
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleRowSelect(item, index)), ["stop"])
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => ((item.isChecked) = $event),
                                        disabled: 
                              (_ctx.formData.order_progress ===
                                _ctx.OrderRequestProgress.Requested &&
                                item.confirmed_flag === 1) ||
                              (_ctx.formData.order_progress ===
                                _ctx.OrderRequestProgress.Confirmed &&
                                item.shipped_flag === 1) ||
                              _ctx.loading
                            
                                      }, null, 8, _hoisted_26), [
                                        [_vModelCheckbox, item.isChecked]
                                      ])
                                    ], 10, _hoisted_25)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                      (item.__show.product_gallery)
                                        ? (_openBlock(), _createBlock(_component_el_image, {
                                            key: 0,
                                            class: "w-100 h-100 cursor-pointer",
                                            src: 
                                  item.__show.product_gallery +
                                  '?x-oss-process=image/resize,l_200'
                                ,
                                            fit: "contain",
                                            onClick: ($event: any) => (
                                  _ctx.previewImages(
                                    [item.__show.product_gallery],
                                    0
                                  )
                                )
                                          }, null, 8, ["src", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, _toDisplayString(item.brand_name), 1),
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(item.__show.product_name), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(item.article_no), 1),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.t("order.size")) + ": " + _toDisplayString(item.size), 1),
                                    _createElementVNode("div", null, _toDisplayString(_ctx.t("order.color")) + ": " + _toDisplayString(item.color), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.t("orderRequest.pcsRequest")), 1),
                                  _createElementVNode("span", null, ": " + _toDisplayString(item.request_qty), 1)
                                ]),
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.t("orderRequest.pcsConfirmed")), 1),
                                  _createElementVNode("span", null, ": " + _toDisplayString(item.confirmed_qty), 1),
                                  _createVNode(_component_el_popover, {
                                    placement: "top",
                                    width: "auto",
                                    trigger: "click"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_62, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, [
                                          _createElementVNode("table", _hoisted_46, [
                                            _createElementVNode("thead", null, [
                                              _createElementVNode("tr", _hoisted_47, [
                                                _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.t("orderRequest.salesOrderNo")), 1),
                                                _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.t("orderRequest.fulNo")), 1),
                                                _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.t("orderRequest.oldFulNo")), 1),
                                                _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.t("orderRequest.qty")), 1)
                                              ])
                                            ]),
                                            _createElementVNode("tbody", _hoisted_52, [
                                              (
                                        item.relation_fulfillment.length > 0
                                      )
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.relation_fulfillment, (re, reIndex) => {
                                                    return (_openBlock(), _createElementBlock("tr", { key: reIndex }, [
                                                      _createElementVNode("td", _hoisted_53, [
                                                        _createTextVNode(_toDisplayString(re.sale_order_number) + " ", 1),
                                                        _hoisted_54,
                                                        (
                                                re.sales_order_sub_total > 0
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, " SUB#" + _toDisplayString(re.sales_order_sub_position) + " of " + _toDisplayString(re.sales_order_sub_total), 1))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _createElementVNode("td", _hoisted_56, _toDisplayString(re.fulfillment_order_number), 1),
                                                      _createElementVNode("td", _hoisted_57, _toDisplayString(re.old_fulfillment_id), 1),
                                                      _createElementVNode("td", _hoisted_58, _toDisplayString(re.dispatch_qty), 1)
                                                    ]))
                                                  }), 128))
                                                : (_openBlock(), _createElementBlock("tr", _hoisted_59, _hoisted_61))
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.t("orderRequest.pcsShipped")), 1),
                                  _createElementVNode("span", null, ": " + _toDisplayString(item.shipped_qty), 1)
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.t("orderRequest.pcsRejected")), 1),
                                  _createElementVNode("span", null, ": " + _toDisplayString(item.rejected_qty), 1)
                                ])
                              ]),
                              (0)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_67, [
                                    _createElementVNode("button", {
                                      disabled: 
                            _ctx.isDisabledItem(item) ||
                            _ctx.formData.order_progress >=
                              _ctx.OrderRequestProgress.Confirmed
                          ,
                                      onClick: ($event: any) => (_ctx.addSubItem(item, index)),
                                      type: "button",
                                      class: "btn btn-icon toggle-btn btn-bg-light btn-active-color-primary btn-sm"
                                    }, [
                                      _createElementVNode("span", _hoisted_69, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                                      ])
                                    ], 8, _hoisted_68)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (item.relation_shipment.length)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.relation_shipment, (row, rowIndex) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    class: "subtable_template relation-shipment text-start text-xs",
                                    key: rowIndex
                                  }, [
                                    (0)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_70))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", _hoisted_71, [
                                      _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, [
                                          _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.t("order.merchantOrderNo")), 1),
                                          _createElementVNode("span", null, ": " + _toDisplayString(row.merchant_order_number), 1)
                                        ]),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(_ctx.t("order.merchantOrderNo")), 1))
                                          : _createCommentVNode("", true),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                              _createVNode(_component_el_form_item, {
                                                class: "m-0",
                                                rules: 
                                  _ctx.rules[
                                    'relation_items.relation_shipment.merchant_order_number'
                                  ]
                                ,
                                                prop: 
                                  'relation_items.' +
                                  index +
                                  '.relation_shipment.' +
                                  rowIndex +
                                  '.merchant_order_number'
                                
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: row.merchant_order_number,
                                                    "onUpdate:modelValue": ($event: any) => ((row.merchant_order_number) = $event),
                                                    type: "text",
                                                    placeholder: _ctx.t('common.plsEnter'),
                                                    clearable: "",
                                                    disabled: 
                                    _ctx.formData.order_progress >=
                                    _ctx.OrderRequestProgress.Shipped
                                  
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1032, ["rules", "prop"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_77, [
                                      _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                          _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.t("orderRequest.merchantInvoiceNo")), 1),
                                          _createElementVNode("span", null, ": " + _toDisplayString(row.merchant_invoice_number), 1)
                                        ]),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.t("orderRequest.merchantInvoiceNo")), 1))
                                          : _createCommentVNode("", true),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                              _createTextVNode(_toDisplayString(row.merchant_invoice_number) + " ", 1),
                                              _createVNode(_component_el_form_item, {
                                                class: "m-0",
                                                rules: 
                                  _ctx.rules[
                                    'relation_items.relation_shipment.merchant_invoice_number'
                                  ]
                                ,
                                                prop: 
                                  'relation_items.' +
                                  index +
                                  '.relation_shipment.' +
                                  rowIndex +
                                  '.merchant_invoice_number'
                                
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: row.merchant_invoice_number,
                                                    "onUpdate:modelValue": ($event: any) => ((row.merchant_invoice_number) = $event),
                                                    type: "text",
                                                    placeholder: _ctx.t('common.plsEnter'),
                                                    clearable: "",
                                                    disabled: 
                                    _ctx.formData.order_progress >=
                                    _ctx.OrderRequestProgress.Shipped
                                  
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1032, ["rules", "prop"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (0)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_83, [
                                          _createElementVNode("div", _hoisted_84, [
                                            _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.t("orderRequest.confirmationDate")), 1),
                                            _createElementVNode("div", _hoisted_86, [
                                              _createVNode(_component_el_form_item, {
                                                class: "m-0",
                                                rules: 
                                  _ctx.rules[
                                    'relation_items.relation_shipment.confirmation_date'
                                  ]
                                ,
                                                prop: 
                                  'relation_items.' +
                                  index +
                                  '.relation_shipment.' +
                                  rowIndex +
                                  '.confirmation_date'
                                
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_date_picker, {
                                                    class: "w-100",
                                                    modelValue: row.confirmation_date,
                                                    "onUpdate:modelValue": ($event: any) => ((row.confirmation_date) = $event),
                                                    type: "date",
                                                    placeholder: _ctx.t('common.pickDate'),
                                                    onChange: ($event: any) => (
                                    _ctx.dateChange(
                                      $event,
                                      index,
                                      rowIndex,
                                      'confirmation_date'
                                    )
                                  ),
                                                    disabled: 
                                    _ctx.formData.order_progress >=
                                    _ctx.OrderRequestProgress.Confirmed
                                  
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1032, ["rules", "prop"])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", _hoisted_87, [
                                      _createElementVNode("div", _hoisted_88, [
                                        _createElementVNode("div", _hoisted_89, [
                                          _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.t("orderRequest.shippingDate")), 1),
                                          _createElementVNode("span", null, ": " + _toDisplayString(_ctx.formatDate(row.shipping_date)), 1)
                                        ]),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(_ctx.t("orderRequest.shippingDate")), 1))
                                          : _createCommentVNode("", true),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                              (0)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 0,
                                                    class: "m-0",
                                                    rules: 
                                  _ctx.rules[
                                    'relation_items.relation_shipment.shipping_date'
                                  ]
                                ,
                                                    prop: 
                                  'relation_items.' +
                                  index +
                                  '.relation_shipment.' +
                                  rowIndex +
                                  '.shipping_date'
                                
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_date_picker, {
                                                        class: "w-100",
                                                        modelValue: row.shipping_date,
                                                        "onUpdate:modelValue": ($event: any) => ((row.shipping_date) = $event),
                                                        type: "date",
                                                        placeholder: _ctx.t('common.pickDate'),
                                                        onChange: ($event: any) => (
                                    _ctx.dateChange(
                                      $event,
                                      index,
                                      rowIndex,
                                      'shipping_date'
                                    )
                                  ),
                                                        disabled: 
                                    _ctx.formData.order_progress >=
                                    _ctx.OrderRequestProgress.Shipped
                                  
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["rules", "prop"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_93, [
                                      _createElementVNode("div", _hoisted_94, [
                                        _createElementVNode("div", _hoisted_95, [
                                          _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.t("shipments.serviceProvider")), 1),
                                          _createElementVNode("span", null, ": " + _toDisplayString(row.__show.service_provider), 1)
                                        ]),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_ctx.t("shipments.serviceProvider")), 1))
                                          : _createCommentVNode("", true),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                              (0)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 0,
                                                    class: "m-0",
                                                    rules: 
                                  _ctx.rules[
                                    'relation_items.relation_shipment.service_provider'
                                  ]
                                ,
                                                    prop: 
                                  'relation_items.' +
                                  index +
                                  '.relation_shipment.' +
                                  rowIndex +
                                  '.service_provider'
                                
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_select, {
                                                        class: "w-100",
                                                        modelValue: row.service_provider,
                                                        "onUpdate:modelValue": ($event: any) => ((row.service_provider) = $event),
                                                        filterable: "",
                                                        clearable: "",
                                                        placeholder: _ctx.t('common.plsSelect'),
                                                        disabled: 
                                    _ctx.formData.order_progress >=
                                    _ctx.OrderRequestProgress.Shipped
                                  
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.service_provider, (item) => {
                                                            return (_openBlock(), _createBlock(_component_el_option, {
                                                              key: item.value,
                                                              label: item.label,
                                                              value: item.value
                                                            }, null, 8, ["label", "value"]))
                                                          }), 128))
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["rules", "prop"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_99, [
                                      _createElementVNode("div", _hoisted_100, [
                                        _createElementVNode("div", _hoisted_101, [
                                          _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.t("shipments.trackingNo")), 1),
                                          _createElementVNode("span", null, ": " + _toDisplayString(row.tracking_no), 1)
                                        ]),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_ctx.t("shipments.trackingNo")), 1))
                                          : _createCommentVNode("", true),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                              _createVNode(_component_el_form_item, {
                                                class: "m-0",
                                                rules: 
                                  _ctx.rules[
                                    'relation_items.relation_shipment.tracking_no'
                                  ]
                                ,
                                                prop: 
                                  'relation_items.' +
                                  index +
                                  '.relation_shipment.' +
                                  rowIndex +
                                  '.tracking_no'
                                
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    modelValue: row.tracking_no,
                                                    "onUpdate:modelValue": ($event: any) => ((row.tracking_no) = $event),
                                                    type: "text",
                                                    placeholder: _ctx.t('common.plsEnter'),
                                                    clearable: "",
                                                    disabled: 
                                    _ctx.formData.order_progress >=
                                    _ctx.OrderRequestProgress.Shipped
                                  
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1032, ["rules", "prop"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_105, [
                                      _createElementVNode("div", _hoisted_106, [
                                        _createElementVNode("div", _hoisted_107, [
                                          _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.t("orderRequest.pcsShipped")), 1),
                                          _createElementVNode("span", null, ": " + _toDisplayString(row.shipping_qty), 1)
                                        ]),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.t("orderRequest.pcsShipped")), 1))
                                          : _createCommentVNode("", true),
                                        (0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                              (0)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 0,
                                                    class: "m-0",
                                                    rules: 
                                  _ctx.rules[
                                    'relation_items.relation_shipment.shipping_qty'
                                  ]
                                ,
                                                    prop: 
                                  'relation_items.' +
                                  index +
                                  '.relation_shipment.' +
                                  rowIndex +
                                  '.shipping_qty'
                                
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_111, [
                                                        _createVNode(_component_el_input_number, {
                                                          class: "text-end w-100",
                                                          modelValue: row.shipping_qty,
                                                          "onUpdate:modelValue": ($event: any) => ((row.shipping_qty) = $event),
                                                          precision: 0,
                                                          step: 1,
                                                          min: 1,
                                                          max: _ctx.subQtyMax(item, rowIndex),
                                                          controls: false,
                                                          disabled: 
                                      _ctx.formData.order_progress >=
                                      _ctx.OrderRequestProgress.Confirmed
                                    ,
                                                          onChange: ($event: any) => (
                                      _ctx.shippingQtyChange(
                                        $event,
                                        item,
                                        index,
                                        row,
                                        rowIndex
                                      )
                                    )
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "disabled", "onChange"])
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["rules", "prop"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (0)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_112, [
                                          (0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                disabled: 
                              _ctx.formData.order_progress >
                              _ctx.OrderRequestProgress.Confirmed
                            ,
                                                onClick: ($event: any) => (_ctx.editSubItem(item, index, row, rowIndex)),
                                                type: "button",
                                                "data-bs-toggle": "modal",
                                                "data-bs-target": "#modal_add_order_request_item_sub",
                                                class: "btn btn-icon toggle-btn btn-bg-light btn-active-color-primary btn-sm me-2"
                                              }, [
                                                _createElementVNode("span", _hoisted_114, [
                                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                                ])
                                              ], 8, _hoisted_113))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("button", {
                                            disabled: 
                              _ctx.formData.order_progress >
                              _ctx.OrderRequestProgress.Confirmed
                            ,
                                            onClick: ($event: any) => (_ctx.copySubItem(item, index, row, rowIndex)),
                                            type: "button",
                                            class: "btn btn-icon toggle-btn btn-bg-light btn-active-color-primary btn-sm me-2"
                                          }, [
                                            _createElementVNode("span", _hoisted_116, [
                                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen054.svg" })
                                            ])
                                          ], 8, _hoisted_115),
                                          _createElementVNode("button", {
                                            disabled: 
                              _ctx.formData.order_progress >=
                              _ctx.OrderRequestProgress.Confirmed
                            ,
                                            onClick: ($event: any) => (_ctx.deleteSubItem(item, index, row, rowIndex)),
                                            type: "button",
                                            class: "btn btn-icon toggle-btn btn-bg-light btn-light-danger btn-sm"
                                          }, [
                                            _createElementVNode("span", _hoisted_118, [
                                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                                            ])
                                          ], 8, _hoisted_117)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      : (_openBlock(), _createElementBlock("tr", _hoisted_119, [
                          _createElementVNode("td", _hoisted_120, [
                            _createElementVNode("p", null, [
                              (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_121, "No data found"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                  ])
                ])
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, _hoisted_124))
                : _createCommentVNode("", true)
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_125, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_126,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            (_ctx.formData.order_progress === _ctx.OrderRequestProgress.New)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: _ctx.loading,
                  type: "button",
                  class: "btn btn-light-dark me-2",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.canceledOrderRequest && _ctx.canceledOrderRequest(...args)))
                }, [
                  _createElementVNode("span", _hoisted_128, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.canceled")), 1)
                ], 8, _hoisted_127))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_item_modal, {
      itemId: _ctx.itemId,
      itemData: _ctx.itemData,
      editData: _ctx.itemSubData,
      itemSubIndex: _ctx.itemSubIndex,
      serviceProvider: _ctx.options.service_provider,
      orderProgress: _ctx.formData.order_progress,
      onUpdateList: _ctx.updateList,
      onResetForm: _ctx.handleReset
    }, null, 8, ["itemId", "itemData", "editData", "itemSubIndex", "serviceProvider", "orderProgress", "onUpdateList", "onResetForm"]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}